/* eslint-disable no-unused-vars */
import { store } from 'redux/store';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { equipmentAssociatedOrNewPsvsTransformer } from './psvs';
import { prepareInspectionCMLForBackend } from './inspection-cml';

export const transformFormWrapperDataToNewInspection = ({ inspectionData, inspectionId }) => {
  let newRecordId = localStorage.getItem('newRecordId') || uuidv4();

  const uniqueId = !_.isEmpty(inspectionId) ? inspectionId : newRecordId;
  let workOrderIds =
    inspectionData?.inspectionWorkOrder?.length > 0
      ? inspectionData?.inspectionWorkOrder?.map((x) => x?.id)
      : [];

  let workRequestIds =
    inspectionData?.inspectionWorkRequest?.length > 0
      ? inspectionData?.inspectionWorkRequest?.map((x) => x?.id)
      : [];

  const previousWorkOrderIds =
    inspectionData?.workOrderIds?.length > 0 ? inspectionData?.workOrderIds : [];
  workOrderIds = [...workOrderIds, ...previousWorkOrderIds];

  const previousWorkRequestIds =
    inspectionData?.workRequestIds?.length > 0 ? inspectionData?.workRequestIds : [];
  workRequestIds = [...workRequestIds, ...previousWorkRequestIds];

  const { pipeline, structure, cache } = store.getState();
  const { pipelineMobileMap = {}, pipelineMobile = [] } = pipeline;
  const { structureMobile = [], structureMobileMap = {} } = structure;
  const { equipmentsMap = {}, equipments: cacheEquipments = [] } = cache;

  let appliesToType = '';
  let uniqueSiteIdsForPipeline = [];
  let structureSiteId = '';
  let equipmentSiteId = '';
  if (!inspectionId || !inspectionData?.appliesToType) {
    appliesToType = inspectionData?.siteId
      ? 'site'
      : inspectionData?.equipmentId
      ? 'equipment'
      : inspectionData?.structureId
      ? 'structure'
      : inspectionData?.pipelineId
      ? 'pipeline'
      : '';
  } else {
    appliesToType = inspectionData?.appliesToType;
  }

  if (appliesToType === 'pipeline') {
    const pipeLineData = inspectionId
      ? {}
      : pipelineMobile[pipelineMobileMap[inspectionData?.pipelineId]] || {};

    const siteIds = pipeLineData
      ? new Set([
          ...(pipeLineData?.fromSite ? [pipeLineData.fromSite] : []),
          ...(pipeLineData?.toSite ? [pipeLineData.toSite] : []),
          ...(pipeLineData?.sites?.map((x) => x.toLowerCase()) ?? []),
          ...(pipeLineData?.wells?.map((x) => x.toLowerCase()) ?? [])
        ])
      : [];

    // get unique site ids, if work request created from pipeline
    uniqueSiteIdsForPipeline = inspectionData?.sites || Array.from(siteIds);
  } else if (appliesToType === 'structure') {
    const structureData = inspectionId
      ? {}
      : structureMobile[structureMobileMap[inspectionData?.structureId]] || {};
    structureSiteId = inspectionData?.siteId || structureData?.siteId;
  } else if (appliesToType === 'equipment') {
    const equipmentData =
      inspectionId && inspectionData?.appliesToType && inspectionData?.siteId
        ? {}
        : cacheEquipments[equipmentsMap[inspectionData?.equipmentId]] || {};
    equipmentSiteId = inspectionData?.siteId || equipmentData?.siteId;
  }

  return {
    appliesToType,
    newInspection: true,
    status: inspectionData?.status,
    type: 'Inspection',
    id: uniqueId,
    inspectionFormId: inspectionData?.inspectionFormId,
    inspectionTypeId: inspectionData?.inspectionTypeId,
    siteId: inspectionData?.siteId || structureSiteId || equipmentSiteId || null,
    equipmentId: inspectionData?.equipmentId || null,
    pipelineId: inspectionData?.pipelineId || null,
    formData: inspectionData?.formData || null,
    startLatitude: inspectionData?.startLatitude,
    startLongitude: inspectionData?.startLongitude,
    completionLatitude: inspectionData?.completionLatitude,
    completionLongitude: inspectionData?.completionLongitude,
    inspectionDate: inspectionData?.inspectionDate
      ? inspectionData?.inspectionDate
      : moment().format('YYYY-MM-DDTHH:mm:ss'),
    ...(workOrderIds?.length > 0 && {
      workOrderIds
    }),

    ...(workRequestIds?.length > 0 && {
      workRequestIds
    }),
    sites: uniqueSiteIdsForPipeline,
    ...(inspectionData?.relatedPSVId && { relatedPSVId: inspectionData?.relatedPSVId }),
    ...(inspectionData?.newRelatedPSV && { newRelatedPSV: inspectionData?.newRelatedPSV }),

    ...(inspectionData?.relatedPVId && { relatedPVId: inspectionData?.relatedPVId }),
    ...(inspectionData?.newRelatedPV && { newRelatedPV: inspectionData?.newRelatedPV })
  };
};

export const prepareInspectionForBackend = (
  data,
  failureCriteria,
  inspectionFormsUserCache,
  passFailTrue,
  passFailNA,
  passFailFalse,
  inspectionResultAnswer,
  passFailList,
  passDeficiencyFail,
  formData,
  psvs,
  equipmentsMap,
  cacheEquipments
) => {
  const currentFrom =
    inspectionFormsUserCache?.find((x) => x?.inspectionFormId === data?.inspectionFormId) || {};
  const equipmentAssociatedPsvs = equipmentAssociatedOrNewPsvsTransformer({
    formDataPSVs: psvs || [],
    equipmentId: data?.equipmentId || ''
  });
  const { json, cmlList } = transformJSON({
    currentFrom,
    formData,
    currentTask: data,
    newRelatedPV: data?.newRelatedPV,
    relatedPSVId: data?.relatedPSVId,
    newRelatedPSV: data?.newRelatedPSV,
    relatedPVId: data?.relatedPVId
  });

  const failureCriteriaMap = failureCriteria?.reduce((acc, curr) => {
    acc[curr.value] = curr.label;
    return acc;
  }, {});

  let inspectionPassed = checkIsInspectionIsPassedOrNot({
    failureCriteriaMap,
    currentFrom,
    inspectionResultAnswer,
    passFailList,
    passDeficiencyFail,
    passFailFalse
  });

  let equipmentNewId = '';
  if (
    data?.equipmentId &&
    equipmentsMap[data.equipmentId] >= 0 &&
    cacheEquipments[equipmentsMap[data.equipmentId]]?.isNew
  ) {
    equipmentNewId = data.equipmentId;
  } else if (
    data?.equipmentId &&
    (equipmentsMap[data.equipmentId] < 0 || !equipmentsMap[data.equipmentId])
  ) {
    equipmentNewId = data.equipmentId;
  }

  const transformData = {
    runId: data?.runId || null,
    RunName: data?.RunName || null,
    runNumber: data?.runNumber || null,
    inspectableItemId: data?.inspectableItemId || null,
    siteId: data?.siteId || null,
    ...(equipmentNewId && { onDemandId: equipmentNewId }),
    ...(!equipmentNewId && data?.equipmentId && { equipmentId: data?.equipmentId }),

    pipelineId: data?.pipelineId || null,
    pipelines: data?.pipelines?.length
      ? data?.pipelines
      : data?.pipelineId
      ? [data?.pipelineId]
      : [],
    sites: data?.sites?.length > 0 ? data?.sites : [],
    inspectionTypeId: data?.inspectionTypeId || null,
    inspectionFormId: data?.inspectionFormId || null,
    frequencyId: data?.frequencyId || null,
    nextDue: data?.nextDue || null,
    nextScheduled: data?.nextScheduled || null,
    inspectionId: data?.id || uuidv4(),
    json: null,
    uniqueDeviceId: null,
    types: null,
    structureSelectInfo: null,
    inspectionDate: data?.inspectionDate || moment().format('YYYY-MM-DD'),
    inspectionPassed: inspectionPassed,
    onDemandItem: null,
    sensors: [],
    ...(data?.workOrderIds && { workOrderIds: data?.workOrderIds }),
    ...(data?.workRequestIds && { workRequestIds: data?.workRequestIds }),
    ...(equipmentAssociatedPsvs?.length > 0 && {
      equipmentAssociatedPsvs: equipmentAssociatedPsvs
    }),
    formdata: json,
    startLatitude: data?.startLatitude ? `${data?.startLatitude}` : null,
    startLongitude: data?.startLongitude ? `${data?.startLongitude}` : null,
    completionLatitude: data?.completionLatitude ? `${data?.completionLatitude}` : null,
    completionLongitude: data?.completionLongitude ? `${data?.completionLongitude}` : null

    // ...(data?.relatedPSVId && { relatedPSVId: data?.relatedPSVId }),
    // ...(data?.newRelatedPSV && { newRelatedPSV: data?.newRelatedPSV }),

    // ...(data?.relatedPVId && { relatedPVId: data?.relatedPVId }),
    // ...(data?.newRelatedPV && { newRelatedPV: data?.newRelatedPV })
  };
  return { transformData, cmlList };
};

const getDefaultValueWhenInspectionResultSelected = ({ form }) => {
  let defaultValue = null;
  for (const section of form.formSections) {
    for (const field of section.formFields) {
      if (field.questionTypeText === 'InspectionResult') {
        defaultValue = field.defaultValue;
        break;
      }
    }
    if (defaultValue) {
      break;
    }
  }
  return defaultValue;
};

export const transformJSON = ({
  currentFrom,
  formData,
  newRelatedPV,
  relatedPSVId,
  newRelatedPSV,
  relatedPVId,
  currentTask
}) => {
  const formDataAnswers = [];
  let cmlList = [];
  currentFrom?.formSections?.map((section) => {
    section?.formFields?.map((field) => {
      let removeSpecialCharactersForName = removeSpecialCharacters(
        field?.label?.toString()?.toLowerCase()
      );
      removeSpecialCharactersForName = `${removeSpecialCharactersForName}-${field?.formFieldId}`;
      const answer =
        field?.questionTypeText === 'PhotoQuestion'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.notes
          : field?.questionTypeText === 'PassFailNA' ||
            field?.questionTypeText === 'PassFail' ||
            field?.questionTypeText === 'Scale'
          ? field?.questionTypeText === 'Scale'
            ? parseInt(formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.answer) === 0
              ? 0
              : formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.answer
            : formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.answer || null
          : field?.questionTypeText === 'YNComment'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.value
          : field?.questionTypeText === 'Readings' || field?.questionTypeText === 'Readings_PL'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.textBoxValue
          : field?.questionTypeText === 'Photos'
          ? null
          : field?.questionTypeText === 'InspectionResult'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.inspectionResultAnswer
          : field?.questionTypeText === 'Signature'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.signaturePhoto
          : field?.questionTypeText === 'Time'
          ? moment(formData[removeSpecialCharactersForName]?.[field?.formFieldId]).format('hh:mm')
          : field?.questionTypeText === 'UT_CML_Section'
          ? false
          : formData[removeSpecialCharactersForName]?.[field?.formFieldId];
      const assessment =
        field?.questionTypeText === 'Scale'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.assessment
          : null;
      const comment =
        field?.questionTypeText === 'YNComment'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.comment
          : null;

      const notes = ['PhotoQuestion', 'PassFailNA', 'PassFail', 'Scale']?.includes(
        field?.questionTypeText
      )
        ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.notes
        : field?.questionTypeText === 'YNComment'
        ? formData[removeSpecialCharactersForName]?.[field?.form]?.comment
        : null;
      const unit =
        field?.questionTypeText === 'Readings' || field?.questionTypeText === 'Readings_PL'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.textBoxUnitValue
          : null;
      const photos =
        field?.questionTypeText === 'Photos' ||
        ['PhotoQuestion', 'PassFailNA', 'PassFail', 'Scale']?.includes(field?.questionTypeText)
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.photos?.map((x) => {
              return {
                photoId: x?.id,
                caption: x?.caption
              };
            })
          : null;
      const documentId =
        field?.questionTypeText === 'Photos'
          ? formData[removeSpecialCharactersForName]?.[field?.formFieldId]?.documents?.at(0)?.id
          : null;
      const documentObj = documentId
        ? {
            fieldKey: field?.label,
            fieldId: field?.formFieldId,
            documentId
          }
        : null;
      const multipleDropdownAnswer =
        field?.questionTypeText === 'Dropdown_PL_Multiple' &&
        formData[removeSpecialCharactersForName]?.[field?.formFieldId]
          ? Object.values(formData[removeSpecialCharactersForName]?.[field?.formFieldId])?.map(
              (x) => x?.value
            )
          : null;

      documentObj && formDataAnswers.push(documentObj);
      if (!['PSV_Section', 'UT_CML_Section'].includes(field?.questionTypeText)) {
        formDataAnswers.push({
          fieldKey: field?.label,
          fieldId: field?.formFieldId,

          ...(field.sourceEntity === 'RelatedPSV' &&
            relatedPSVId && {
              relatedPSVId: relatedPSVId
            }),

          ...(field.sourceEntity === 'RelatedPSV' &&
            newRelatedPSV && {
              newRelatedPSV: newRelatedPSV
            }),

          ...(field.sourceEntity === 'RelatedPV' &&
            relatedPVId && {
              relatedPVId: relatedPVId
            }),

          ...(field.sourceEntity === 'RelatedPV' &&
            newRelatedPV && {
              newRelatedPV: newRelatedPV
            }),

          ...(answer &&
            !multipleDropdownAnswer && {
              answer: answer?.toString()
            }),
          ...(multipleDropdownAnswer && {
            listOfMultiValueIds: multipleDropdownAnswer
          }),
          ...(field?.questionTypeText === 'Scale' &&
            assessment && {
              assessment
            }),
          ...(['Scale', 'Numeric'].includes(field?.questionTypeText) &&
            answer === 0 && {
              answer: answer?.toString()
            }),
          ...(notes && {
            notes
          }),
          ...(unit && {
            unit
          }),
          ...(photos && {
            photos
          }),
          ...(comment && {
            comment
          }),
          ...(field?.questionTypeText === 'YN' && {
            answer: answer?.toString()
          }),
          ...(['Readings', 'Readings_PL'].includes(field?.questionTypeText) &&
            answer === 0 && {
              answer: answer?.toString()
            })
        });
      }

      if (field?.questionTypeText === 'UT_CML_Section') {
        const cmlData = formData[removeSpecialCharactersForName]?.[field?.formFieldId];
        cmlList = prepareInspectionCMLForBackend({
          currentTask: currentTask,
          formData,
          cmlDataList: cmlData?.cml || []
        });
      }
    });
  });
  return { json: formDataAnswers, cmlList };
};

const removeSpecialCharacters = (str) => {
  const pattern = /[^a-zA-Z0-9 ]/g;
  const result = str.replace(pattern, '');
  return result;
};

export const checkIsInspectionIsPassedOrNot = ({
  failureCriteriaMap,
  currentFrom,
  inspectionResultAnswer,
  passFailList,
  passDeficiencyFail,
  passFailFalse
}) => {
  let inspectionPassed = false;
  if (failureCriteriaMap[currentFrom?.failureCriteria] === 'Auto pass') inspectionPassed = true;
  else if (failureCriteriaMap[currentFrom?.failureCriteria] === 'No pass/fail outcome')
    inspectionPassed = null;
  else if (failureCriteriaMap[currentFrom?.failureCriteria] === '‘Inspection Result’ section') {
    const defaultValue = getDefaultValueWhenInspectionResultSelected({ form: currentFrom });
    if (defaultValue === 'InspResult_PassFailList') {
      const condition =
        inspectionResultAnswer || (currentFrom?.quickComplete ? passFailList[0]?.value : null);
      inspectionPassed = condition === 'true' ? true : false;
    } else if (defaultValue === 'InspResult_PassDeficiencyFailList') {
      const condition =
        inspectionResultAnswer ||
        (currentFrom?.quickComplete ? passDeficiencyFail[0]?.value : null);
      inspectionPassed = condition === 'pass' || condition === 'pass_minor' ? true : false;
    } else {
      inspectionPassed = false;
    }
  } else if (
    failureCriteriaMap[currentFrom?.failureCriteria] === 'A number of Pass-Fail failures'
  ) {
    const numberOfFailedFields = currentFrom?.numberOfFailedFields || 0;
    if (passFailFalse >= numberOfFailedFields) inspectionPassed = false;
    else inspectionPassed = true;
  }
  return inspectionPassed;
};
